<template>
  <div class="xpress-home-page">
    <!-- preload -->
    <n-modal v-model:show="loading">
      <page-spinner :onloader="'flex'" />
    </n-modal>

    <!--header section  -->
    <main-header />

    <!--main section  -->
    <main class="xpress-home-content">
      <section>
        <div>
          <h1>Make Bulk &amp; Single payments <span class="xpress-animated-text">
            <vue-writer
              class="d-inline"
              :array="['with ease', 'quickly', 'securely']"
              :delay="2000"
            />
          </span></h1>
          <p>
            With XpressPayout, you can make bulk or single payments on the go from multiple accounts and multiple banks. Transfer funds through the web securely &amp; with ease.
          </p>
          <div v-if="!user">
            <button
              @click="handleGetStarted"
              class="xpress-get-started-btn"
            >
              <span>Get started</span>
              <img src="../assets/img/icons/white-arr-right.png" alt="arrow icon">
            </button>
          </div>
        </div>
        <figure class="xpress-banner-image-box">
          <img :src="bannerImg" alt="Payment information Image">
        </figure>
      </section>
    </main>
    <!-- ------------- -->
    <MainFooter />
  </div>
</template>

<script>
import { computed, onBeforeMount, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { NModal } from 'naive-ui'
import VueWriter from 'vue-writer'

import MainHeader from '@/components/mainHeader.vue'
import MainFooter from '@/components/mainFooter.vue'
import PageSpinner from '@/components/PageSpinner.vue'
import MerchantPortalAuthenticator from 'xpress_merchant_authenticator'
import { useRoute } from 'vue-router'
import { getMerchantPortalUrl, getStartedUrl } from '@/utils/appConfig'

export default {
  name: 'Home',
  components: {
    NModal,
    VueWriter,
    PageSpinner,
    MainHeader,
    MainFooter
  },
  setup () {
    const store = useStore()

    const loading = computed(() => store.getters._globalLoading)
    const user = computed(() => store.getters['users/_user'])

    const bannerImg = require('@/assets/img/home/Payment-Information.gif')

    const query = useRoute().query
    const portalDomain = ref(window.location.href?.split('?tk='))

    const handleGetStarted = () => {
      // redirect to merchant portal register page
      window.location.href = `${getStartedUrl()}`
    }

    const getToken = () => {
      if (portalDomain.value?.length === 2) {
        const token = portalDomain.value[1]

        // authenticate user
        authenticateUser(token)
      } else {
        MerchantPortalAuthenticator.getToken({
          appKey: getMerchantPortalUrl(),
          onError: () => {},
          onSuccess: (token) => authenticateUser(token) // authenticate user
        })
      }
    }

    // fetch access token
    const getUrlToken = async () => {
      const token = query.token

      // authenticate user with token
      if (token) authenticateUser(token)
    }

    // authenticate user with token
    const authenticateUser = async (token) => {
      if (token) {
        const ssoToken = token

        const payload = { ssoToken }

        await store.dispatch('users/AuthenticateUser', payload)
          .then(response => {
            // success response
            if ([0, '0', '00'].includes(response?.responseCode)) {
              location.assign('/dashboard')
            }
          })
          .finally(() => {
            MerchantPortalAuthenticator.closeIframe()
          })
      }
    }

    // watch changes in portal domain
    watchEffect(portalDomain.value, getToken())

    // get token from url
    onBeforeMount(getUrlToken)

    // ---------------------------------
    return {
      bannerImg,
      loading,
      user,
      handleGetStarted
    }
  }
}
</script>

<style lang="scss" scoped>
  div.xpress-home-page {
    padding-left: 64px;
    padding-right: 64px;
    display: flex;
    flex-flow: column nowrap;
    row-gap: 27px;
    background-image: url(../assets/img/home/bg-home.png);
    background-repeat: no-repeat;
    background-size: 890px auto;
    background-position: right -10px;
    background-color: #ffffff;

    // &>*:first-child {}

    &>main.xpress-home-content {
      &> section {
        // height: 80vh;
        height: 70vh;
        display: grid;
        grid-template: auto / auto auto;
        align-items: flex-start;

        // text
        &>div {
          // width: 580px;
          width: 630px;
          height: 430px;
          position: relative;
          top: 10px;

          h1 {
            font-family: 'Gelion-Bold-Black';
            font-style: normal;
            font-weight: bold;
            font-size: 60px;
            line-height: 70px;
            color: $xpress-dark-green;

            // animated text
            &>span.xpress-animated-text {
              color: $xpress-orange;
            }
          }
          &>p {
            // margin-top: 48px;
            margin-top: 30px;
            margin-bottom: 40px;
            font-weight: normal;
            font-size: 28px;
            line-height: 34px;
            text-align: justify;
            letter-spacing: 0.003em;
            color: #545454;
          }
          // get started button
          &>div {
            &>button.xpress-get-started-btn {
              width: 186px;
              height: 61px;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              column-gap: 21px;
              border: transparent;
              border-radius: 5px;
              transition: all 0.3s;
              background: $xpress-light-green;
              color: #FFFFFF;

              // hover
              &:hover {
                filter: brightness(0.8);
              }
              // active
              &:active {
                filter: brightness(1);
              }

              // button text
              span {
                // font-family: 'Gelion-Medium';
                font-weight: lighter;
                font-size: 24px;
                line-height: 29px;
                text-transform: capitalize;
              }
              // arrow icon
              // img {}
            }
          }
        }
        // banner image
        &>figure.xpress-banner-image-box {
          width: 100%;
          height: 80%;

          &>img {
            // width: 112%;
            width: 90%;
            height: auto;
            // height: 100%;
            margin-top: -50px;
            margin-left: -15px;
          }
        }
      }
    }
  }

  // MEDIA QUERY

  // XX-SM (<251px)
  @media (max-width: 250.9px) {
    div.xpress-home-page {
      padding-left: 1%;
      padding-right: 1%;

      &>main.xpress-home-content {
        &> section {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column-reverse;
          align-items: center;

          // text
          &>div {
            width: 100%;
            height: fit-content;
            position: static;
            top: 0;
            word-wrap: break-word;

            h1 {
              font-size: 25px;
              line-height: 30px;

              // animated text
              // &>span.xpress-animated-text {}
            }
            &>p {
              margin-top: 20px;
              margin-bottom: 20px;
              font-size: 15px;
              line-height: 20px;
              letter-spacing: normal;
            }
            // get started button
            &>div {
              margin-bottom: 20px;

              &>button.xpress-get-started-btn {
                width: 120px;
                min-width: 101px;
                height: 40px;
                column-gap: 5px;

                // button text
                span {
                  font-size: 18px;
                  line-height: 20px;
                }
                // arrow icon
                img {
                  display: none;
                }
              }
            }
          }
          // banner image
          &>figure.xpress-banner-image-box {
            width: 100%;
            height: fit-content;

            &>img {
              width: 100%;
              height: auto;
              margin-top: 0;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  // XX-SM
  @media (min-width: 251px) and (max-width: 350.9px) {
    div.xpress-home-page {
      padding-left: 1%;
      padding-right: 1%;

      &>main.xpress-home-content {
        &> section {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column-reverse;
          align-items: center;

          // text
          &>div {
            width: 100%;
            height: fit-content;
            position: static;
            word-wrap: break-word;

            h1 {
              font-size: 25px;
              line-height: 30px;

              // animated text
              // &>span.xpress-animated-text {}
            }
            &>p {
              margin-top: 20px;
              margin-bottom: 20px;
              font-size: 15px;
              line-height: 20px;
              letter-spacing: normal;
            }
            // get started button
            &>div {
              margin-bottom: 20px;

              &>button.xpress-get-started-btn {
                width: 120px;
                min-width: 101px;
                height: 40px;
                column-gap: 5px;

                // button text
                span {
                  font-size: 18px;
                  line-height: 20px;
                }
                // arrow icon
                img {
                  display: none;
                }
              }
            }
          }
          // banner image
          &>figure.xpress-banner-image-box {
            width: 100%;
            height: fit-content;

            &>img {
              width: 100%;
              height: auto;
              margin-top: 0;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  // X-SM
  @media (min-width: 351px) and (max-width: 575.9px) {
    div.xpress-home-page {
      padding-left: 2%;
      padding-right: 2%;

      &>main.xpress-home-content {
        &> section {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column-reverse;
          align-items: center;

          // text
          &>div {
            width: 100%;
            height: fit-content;
            position: static;
            word-wrap: break-word;

            h1 {
              font-size: 40px;
              line-height: 37px;

              // animated text
              // &>span.xpress-animated-text {}
            }
            &>p {
              margin-top: 20px;
              margin-bottom: 30px;
              font-size: 18px;
              line-height: 20px;
              letter-spacing: normal;
            }
            // get started button
            &>div {
              margin-bottom: 30px;

              &>button.xpress-get-started-btn {
                width: 140px;
                min-width: 101px;
                height: 50px;
                column-gap: 5px;

                // button text
                span {
                  font-size: 18px;
                  line-height: 20px;
                }
                // arrow icon
                // img {}
              }
            }
          }
          // banner image
          &>figure.xpress-banner-image-box {
            width: 100%;
            height: fit-content;

            &>img {
              width: 100%;
              height: auto;
              margin-top: 0;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  // SM
  @media (min-width: 576px) and (max-width: 767.9px) {
    div.xpress-home-page {
      padding-left: 5%;
      padding-right: 5%;

      &>main.xpress-home-content {
        &> section {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column-reverse;
          align-items: center;

          // text
          &>div {
            width: 100%;
            height: fit-content;
            position: static;
            word-wrap: break-word;

            h1 {
              font-size: 45px;
              line-height: 40px;

              // animated text
              // &>span.xpress-animated-text {}
            }
            &>p {
              margin-top: 20px;
              margin-bottom: 35px;
              font-size: 19.5px;
              line-height: 20px;
              letter-spacing: normal;
            }
            // get started button
            &>div {
              margin-bottom: 30px;

              &>button.xpress-get-started-btn {
                width: 145px;
                min-width: 101px;
                height: 50px;
                column-gap: 8px;

                // button text
                span {
                  font-size: 19px;
                  line-height: 20px;
                }
                // arrow icon
                // img {}
              }
            }
          }
          // banner image
          &>figure.xpress-banner-image-box {
            width: 100%;
            height: fit-content;

            &>img {
              width: 100%;
              height: auto;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  // MD
  @media (min-width: 768px) and (max-width: 991.9px) {
    div.xpress-home-page {
      padding-left: 7%;
      padding-right: 7%;

      &>main.xpress-home-content {
        &> section {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column-reverse;
          align-items: center;

          // text
          &>div {
            width: 100%;
            height: fit-content;
            position: static;
            word-wrap: break-word;

            h1 {
              font-size: 48px;
              line-height: 40px;

              // animated text
              // &>span.xpress-animated-text {}
            }
            &>p {
              margin-top: 20px;
              margin-bottom: 35px;
              font-size: 19.5px;
              line-height: 20px;
              letter-spacing: normal;
            }
            // get started button
            &>div {
              margin-bottom: 30px;

              &>button.xpress-get-started-btn {
                width: 145px;
                min-width: 101px;
                height: 50px;
                column-gap: 8px;

                // button text
                span {
                  font-size: 19px;
                  line-height: 20px;
                }
                // arrow icon
                // img {}
              }
            }
          }
          // banner image
          &>figure.xpress-banner-image-box {
            width: 100%;
            height: fit-content;

            &>img {
              width: 100%;
              height: auto;
              margin-top: 0;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  // LG
  @media (min-width: 992px) and (max-width: 1200.9px) {
    div.xpress-home-page {
      &>main.xpress-home-content {
        &> section {
          width: 100%;
          // text
          &>div {
            width: 450px;
            height: 430px;

            h1 {
              font-size: 50px;
              line-height: 45px;
            }
            &>p {
              margin-top: 30px;
              margin-bottom: 30px;
              font-size: 22px;
              line-height: 24px;
            }
            // get started button
            &>div {
              &>button.xpress-get-started-btn {
                width: 180px;
                height: 55px;
                column-gap: 15px;

                // button text
                span {
                  font-size: 22px;
                  line-height: 29px;
                }
                // arrow icon
                // img {}
              }
            }
          }
          // banner image
          &>figure.xpress-banner-image-box {
            width: auto;
            height: 80%;

            &>img {
              // width: 100%;
              height: auto;
              margin-left: 0;
            }
          }
        }
      }
    }

  }
  // XL
  // @media (max-width: 1201px) {}
</style>
